import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import CardContent from '../components/CardContent.js';
import Card from '../Card.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["image", "lazy", "imageAspectRatio", "imageOverlay", "noBackground", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BaseCard = function BaseCard(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$lazy = _ref.lazy,
    lazy = _ref$lazy === void 0 ? false : _ref$lazy,
    _ref$imageAspectRatio = _ref.imageAspectRatio,
    imageAspectRatio = _ref$imageAspectRatio === void 0 ? null : _ref$imageAspectRatio,
    _ref$imageOverlay = _ref.imageOverlay,
    imageOverlay = _ref$imageOverlay === void 0 ? null : _ref$imageOverlay,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Card, _objectSpread(_objectSpread({}, rest), {}, {
    image: image,
    lazy: lazy,
    imageAspectRatio: imageAspectRatio,
    imageOverlay: imageOverlay,
    noBackground: noBackground,
    children: /*#__PURE__*/jsx(CardContent, {
      children: children
    })
  }));
};
var BaseCard$1 = BaseCard;

export { BaseCard$1 as default };
//# sourceMappingURL=BaseCard.js.map
